import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    containerFlex: {
        flex: 1,
    },
    containerScrollTags: {
        flexGrow: 0,
    },
    containerTags: {
        flexDirection: 'row',
        marginHorizontal: 6,
    },
    containerFinder: {
        paddingHorizontal: 10,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderRadius: 25,
        backgroundColor: theme.colors.inputBackground,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginVertical: 10,
    },
    input: {
        flex: 1,
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
    textResults: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingHorizontal: 10,
        marginVertical: 10,
    },
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        height: '80%',
    },
    image: {
        width: 120,
        height: 120,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    containerTag: {
        flexDirection: 'row',
        paddingHorizontal: 10,
        paddingTop: 10,
        alignContent: 'center',
        alignItems: 'center',
    },
    titleTag: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    lengthTag: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.colorPrimary,
    },
    containerResults: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: 'white',
        // alignItems: 'top',
        paddingHorizontal: 10,
        paddingTop: 5,
    },
    containerItem: {
        flex: 1,
        flexDirection: 'row',
        borderRadius: 15,
        alignItems: 'center',
        paddingVertical: 10,
    },
    containerData: {
        flex: 1,
        marginRight: 10,
    },
    dataAlign: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.2,
        borderBottomColor: theme.colors.lightGray,
        width: '100%',
    },
    imageModuleList: {
        width: 60,
        aspectRatio: 1,
        borderRadius: 10,
        overflow: 'hidden',
    },
    titleModuleList: {
        fontSize: 16,
        fontWeight: 'bold',
        marginLeft: 10,
        marginBottom: 5,
        color: theme.colors.textPrimary,
    },
    descriptionModuleList: {
        fontSize: 14,
        color: theme.colors.textSecondary,
        fontWeight: 'normal',
        marginLeft: 10,
        paddingRight: 0,
    },
    containerStatus: {
        marginTop: 5,
        marginHorizontal: 10,
    },
    statusModuleList: {
        justifyContent: 'center',
        alignContent: 'center',
        borderRadius: 5,
        alignSelf: 'center',
        textAlign: 'center',
    },
    statusModuleText: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
        color: 'white',
        textAlign: 'center',
        textAlignVertical: 'center',
        paddingVertical: 5,
        paddingHorizontal: 10,
    },
    seeMore: {
        alignSelf: 'flex-start',
        marginStart: 20,
    },
    seeActive: {
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.textSecondary,
        textAlign: 'left',
        textAlignVertical: 'center',
        marginTop: 5,
        marginBottom: 20,
    },
    seeLock: {
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.colorPrimary,
        textAlign: 'center',
        textAlignVertical: 'center',
    },
    spacer: {
        paddingBottom: 8,
    },
})

export default styles
